import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TransfersPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransfersPage";
import Classes, { Account } from "model";

export default function CaptureLoanTransferScheduleDD(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const loanAccount = Account.getDefaultBrandedAccountByType("loan");

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .update([ "transfer", "to" ], loanAccount)
        .update([ "transfer", "paymentOption" ], "Payment Due")
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(data.transfer, globalController))
        .update([ "schedule", "isActive" ], true)
        .submit();

    return <TransfersPage data={ data } ui={ ui } />
}